'use client';

import { getSiteConfig } from '@shared/config';
import { Error } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { ErrorStep } from '../../GenericSteps/ErrorStep';
import { getRegistrationFailureKind } from '../utils/registrationFailureKind';

const TRACKING_PROPS = {
  trackContainer: 'Failure Confirmation',
  titleTrackName: 'Error',
  descriptionTrackName: 'Description',
} as const;

function RegistrationFlowErrorStep() {
  const t = useTranslations('register.screens.error');
  const illustration = <Error size="extra-large" />;
  const failureKind = getRegistrationFailureKind();

  if (failureKind === 'restricted') {
    return (
      <ErrorStep
        errorTitle={t('restrictedTitle')}
        errorMessage={t('restrictedDescription')}
        actionText={t('contactUs')}
        illustration={illustration}
        {...TRACKING_PROPS}
        actionButtonTrackName="Contact us"
        actionHref={getSiteConfig().ROUTES.HELP_CENTRE.CONTACT_US}
      />
    );
  }

  return (
    <ErrorStep
      errorTitle={t('systemTitle')}
      errorMessage={t('systemDescription')}
      actionText={t('refresh')}
      illustration={illustration}
      {...TRACKING_PROPS}
      actionButtonTrackName="Refresh"
      onAction={() => {
        window.location.reload();
      }}
    />
  );
}

export { RegistrationFlowErrorStep };
